'use strict';

var widgetId = require('shared/widgetId'),

    normalizeRenderIntoNode = require('widget/scripts/lib/commons/normalizeRenderIntoNode'),
    destroy = require('widget/scripts/lib/api/destroy'),
    onEvent = require('widget/scripts/lib/api/onEvent'),
    getVisualization = require('widget/scripts/lib/api/getVisualization');

Widget.prototype.destroy = destroy;
Widget.prototype.onEvent = onEvent;
Widget.prototype.getVisualization = getVisualization;

module.exports = Widget;

function Widget(targetContainer) {

    var widget = this;

    if (!(widget instanceof(Widget))) {
        return new Widget(targetContainer);
    }

    _bootstrapWidget(widget);
    _storeTargetNode(widget, targetContainer);

    return widget;
}

function _bootstrapWidget(widget) {
    Object.defineProperty(widget, 'id', {
        value: widgetId.generate()
    });
}

function _storeTargetNode(widget, renderIntoNode) {

    _verifyIfNotStoredYet();
    _tryToStoreNode();

    return widget;

    function _verifyIfNotStoredYet() {
        if (widget.parentNode) {
            throw new Error('iVis.Widget: you cannot change the container once it was assigned.');
        }
    }

    function _tryToStoreNode() {
        if (!_isInDOM(widget)) {
            _rememberWhereToRender(widget, normalizeRenderIntoNode(renderIntoNode));
        } else {
            throw new Error('iVis.Widget: visualization already attached to DOM.');
        }
    }

    function _rememberWhereToRender(widget, renderIntoNode) {
        widget.parentNode = renderIntoNode;
    }

    function _isInDOM(widget) {
        return document.getElementById(widget.id) !== null;
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/widget/scripts/lib/api/factory.js
// module id = 12
// module chunks = 0 1